import { defineCatalogue } from '../../i18n';

export const tableCatalogue = defineCatalogue(
  {
    loading: 'Carregando',
    'pagination.label': 'Paginação',
    'pagination.previous': 'Anterior',
    'pagination.next': 'Próxima',
    'pagination.page': 'Página {page} de {pages}',
    'sort.label': 'Ordenar por {column}',
    'sort.ascending': 'crescente',
    'sort.descending': 'decrescente',
  },
  {
    loading: 'Loading',
    'pagination.label': 'Pagination',
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'pagination.page': 'Page {page} of {pages}',
    'sort.label': 'Sort by {column}',
    'sort.ascending': 'ascending',
    'sort.descending': 'descending',
  },
);

export const tt = tableCatalogue.t;
